"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApplicationInsightsNotInitializedError = void 0;
class ApplicationInsightsNotInitializedError extends Error {
  constructor() {
    super('Application Insights not yet initialized');
    this.name = 'ApplicationInsightsNotInitializedError';
  }
}
exports.ApplicationInsightsNotInitializedError = ApplicationInsightsNotInitializedError;
//# sourceMappingURL=ApplicationInsightsNotInitializedError.js.map